import { render } from "./calculatorHeaderCounterComponent.vue?vue&type=template&id=2460d788"
import script from "./calculatorHeaderCounterComponent.vue?vue&type=script&lang=js"
export * from "./calculatorHeaderCounterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__